import React from 'react';

import { VerifyPersonalInfoContents } from '../../components';
import { IdentityProvider } from '../../context';

export function NewFAVerifyPersonalInfoScreen() {
  return (
    <div className="screen">
      <IdentityProvider>
        <VerifyPersonalInfoContents resource="funeral_arrangements" steps={8} nextPath="../disposition" />
      </IdentityProvider>
    </div>
  );
}

